<button
  *ngIf="buttonModel.buttonType === 'raised'"
  mat-flat-button
  color="{{ buttonModel.color }}"
  [disabled]="buttonModel.isDisabled"
>
  {{ buttonModel.title | translate }}
</button>
<button
  *ngIf="buttonModel.buttonType === 'stroked'"
  mat-stroked-button
  color="{{ buttonModel.color }}"
  [disabled]="buttonModel.isDisabled"
>
  {{ buttonModel.title | translate }}
</button>
